import React from 'react';
import { Text } from '@rsos/components/capstone/base';
import SettingsControl from '../../Common/SettingsControl/index';
import {
  AuthorityPairTable,
  AuthorityPairTData,
  AuthorityPairTRow,
  AuthorityPairTHead,
  AuthorityPairTBody,
  AuthorityPairTH,
  TableContainer,
} from '../../Common/SharedStyles.styles.js';
import { alertTypeFormatter } from '../../Common/utils';
import InboundAlertsEmptyState from './InboundAlertsEmptyState';

const InboundAlertsTableComponent = ({ linksFrom }) => {
  return (
    <TableContainer>
      {linksFrom?.length > 0 ? (
        <AuthorityPairTable>
          <AuthorityPairTHead>
            <AuthorityPairTRow>
              <AuthorityPairTH>Name</AuthorityPairTH>
              <AuthorityPairTH>Alert Type</AuthorityPairTH>
              <AuthorityPairTH />
            </AuthorityPairTRow>
          </AuthorityPairTHead>
          {linksFrom.map(link => (
            <AuthorityPairTBody key={link.id}>
              <AuthorityPairTData>
                <Text size="normal" color="secondaryText" ellipsis>
                  {link.link_from.display_name}
                </Text>
              </AuthorityPairTData>
              <AuthorityPairTData>
                <Text size="normal" color="secondaryText">
                  {link.attributes.alert_emergency_types
                    .map(type => alertTypeFormatter(type))
                    .join(', ')}
                </Text>
              </AuthorityPairTData>
              <AuthorityPairTData>
                <SettingsControl authority={link} type="inbound" />
              </AuthorityPairTData>
            </AuthorityPairTBody>
          ))}
        </AuthorityPairTable>
      ) : (
        <InboundAlertsEmptyState />
      )}
    </TableContainer>
  );
};

export default InboundAlertsTableComponent;
